module.exports = __webpack_public_path__ + "static/media/famatel4.696ef43d.jpg";